export const VALUES_FIELD_NAME = [
    'Abel',
    'Arial',
    'Arya',
    'Bebas Neue',
    'Boogaloo',
    'Calibri',
    'Chewy',
    'Dosis',
    'Gill Sans',
    'Goudy Old Style',
    'Heebo',
    'Imprima',
    'Josefin Sans',
    'Lato',
    'Libre Franklin',
    'Mada',
    'Montserrat',
    'Muli',
    'Nobile',
    'Overpass',
    'Pavanam',
    'Poppins',
    'Quicksand',
    'Raleway',
    'Reem Kufi',
    'Roboto',
    'Source Sans Pro',
    'Times New Roman',
    'Tahoma',
    'Tenor Sans',
    'Ubuntu',
    'Varela',
    'Varela Round',
    'Verdana',
] as const;
export type TYPES_FIELD_NAME = typeof VALUES_FIELD_NAME[number];
